import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Chart from "react-apexcharts";
import { Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import ReactECharts from "echarts-for-react";
import { useLocation } from 'react-router-dom';

function ConsumptionChart(props) {

    const { data, timeAggType } = props;

    const { t } = useTranslation();

    let timestamps = data.baseline?.map(
        (item) => timeAggType !== "q"? item.date : (item.date.replace("Q1", "-01-01").replace("Q2", "-04-01").replace("Q3", "-07-01").replace("Q4", "-10-01"))
    ) ?? [];

    let series = [];

    
    series.push({
        name: t("Total"),
        data: data.only_grid?.map((item)=>item.consumption*1000) ?? [],
        type: 'line',
        symbol: 'none',
        lineStyle: {
            width: 4
        }
    })

    series.push({
        name: t("Solar"),
        data: data.baseline?.map((item, i)=>(data.only_grid[i].consumption - item.consumption)*1000) ?? [],
        type: 'line',
        symbol: 'none',
        lineStyle: {
            width: 4
        }
    })

    series.push({
        name: t("Grid"),
        data: data.optimized?.map((item, i)=>item.consumption*1000) ?? [],
        type: 'line',
        symbol: 'none',
        lineStyle: {
            width: 4
        }
    })

    series.push({
        name: t("Co-generation"),
        data: data.baseline?.map((item, i)=>(item.consumption - data.optimized[i].consumption)*1000) ?? [],
        type: 'line',
        symbol: 'none',
        lineStyle: {
            width: 4
        }
    })

    let title = t("Consumption and generation profile") + " [kW]";

    let options = {
            tooltip: {
                trigger: "axis",
                valueFormatter: (value) =>
                    typeof value == "number" ? value.toLocaleString(navigator.language,{
                        minimumFractionDigits:2,
                        maximumFractionDigits:2
                    }) : value,
            },
            grid: {
                top: '4%',
                containLabel: true,
                left: '4%',
                right: '5%',
                bottom: 25
            },
            legend: {
                show: true,
                bottom: 0, 
                left: "center",
                symbol: 'none'
            },
            xAxis: {
                type: 'category',
                data: timestamps,
                silent: false,
            },
            yAxis: {
                splitArea: {
                    show: false,
                },
            },
            textStyle: {
                fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
            },
            series: series,
        };
        
    


    return (
        <Stack>
            <Typography paddingTop={'25px'} align="center" component="h2" variant="h6" color="primary" gutterBottom>{title}</Typography>
            <ReactECharts option={options}/> 
        </Stack>
        
    )

};




export default ConsumptionChart;